(() => {
  function setupVideos(root = document) {
    root.querySelectorAll('[data-video-toggle]').forEach(button => {
      if (button.dataset.ready) return;
      const video = button.closest('.video-banner')?.querySelector('video');
      if (!video) return;
      button.dataset.ready = 'true';
      button.hidden = false;
      const update = () => { button.textContent = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel; };
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      if (motion.matches) video.pause();
      button.addEventListener('click', () => {
        if (video.paused) video.play().catch(update);
        else video.pause();
      });
      video.addEventListener('play', update);
      video.addEventListener('pause', update);
      motion.addEventListener('change', event => { if (event.matches) video.pause(); });
      update();
    });
  }
  setupVideos();
  document.addEventListener('shopify:section:load', event => setupVideos(event.target));
})();
